import {
    Form,
    Input,
    Row,
    Col,
    Switch,
    InputNumber
} from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';

const EditComponent = (props: any) => {
    const apiId = 'topicGroup';
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);

    useEffect(() => {
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        serviceId: 'mf',
        displayOptions: {
            width: 700
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={12}>
                        <Form.Item
                            label="ID"
                            name="id"
                            tooltip="主题的唯一标识，由系统自动生成，创建后不可修改，通常仅用于系统内部关联与追溯。">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="主题组名"
                            name="groupName"
                            rules={[{ required: true, message: '主题组名!' }]}>
                            <Input placeholder="主题组名" />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="排序"
                            name="sort"
                            tooltip="列表展示时的排序权重，数值越小越靠前。用于调整主题在列表中的显示顺序，默认 0。">
                            <InputNumber
                                style={{ width: 90 }} />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            <Switch
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />);
};

export default EditComponent;